import { render, staticRenderFns } from "./AssessmentGroupBandEditorRanges.vue?vue&type=template&id=b2074320&scoped=true"
import script from "./AssessmentGroupBandEditorRanges.vue?vue&type=script&lang=js"
export * from "./AssessmentGroupBandEditorRanges.vue?vue&type=script&lang=js"
import style0 from "./AssessmentGroupBandEditorRanges.vue?vue&type=style&index=0&id=b2074320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2074320",
  null
  
)

export default component.exports